import { ChoicesAnswer, ObjectId } from '../../components/context/SurveyPageContext';

interface BuildChoicesAnswer {
  questionId: number;
  choices: ObjectId[];
  newTextValue: string | null;
}

const buildChoicesAnswer = ({
  questionId,
  choices,
  newTextValue,
}: BuildChoicesAnswer): ChoicesAnswer => ({
  question: { id: questionId },
  choices,
  value: newTextValue,
});

export { buildChoicesAnswer };
